module.exports = __webpack_public_path__ + "img/automq.af21022e.svg";